import request from '@/utils/request'

export function getSignRecords (params) {
  return request({
    url: '/v1/sign/getSignRecords',
    method: 'get',
    params: params
  })
}
export function validateTodayIsSign () {
  return request({
    url: '/v1/sign/validateTodayIsSign',
    method: 'get',
  })
}
export function sign (time) {
  return request({
    url: '/v1/sign/',
    method: 'get',
    params: {
      time: time
    }
  })
}
export function featchLinks () {
  return request({
    url: '/v1/link/',
    method: 'get',
  })
}
export function addLink (data) {
  return request({
    url: '/v1/link/',
    method: 'post',
    data
  })
}
export function report () {
  return request({
    url: '/v1/report',
    method: 'get',
  })
}
// 用户活跃上报
export function reportActive () {
  return request({
    url: '/v1/user/reportActive',
    method: 'get',
  })
}

export function getWebSiteInfo () {
  return request({
    url: '/v1/webSiteInfo',
    method: 'get',
  })
}
export function getNavigations () {
  return request({
    url: '/v1/site/getNavigations',
    method: 'get',
  })
}
// 获取学校选择下拉数据
export const getSchoolList = (params) => {
  return request({
    url: '/v1/school/searchSchool',
    method: 'GET',
    params
  })
}

// 查询当前账号族的全部教育经历（服务端已按最近顺序排列）
export function getEducationList () {
  return request({
    url: '/v1/user/education',
    method: 'get'
  })
}

// 新增教育经历
export function createEducation (data) {
  return request({
    url: '/v1/user/education',
    method: 'post',
    data
  })
}

// 修改教育经历
export function updateEducation (id, data) {
  return request({
    url: `/v1/user/education/${encodeURIComponent(String(id))}`,
    method: 'put',
    data
  })
}

// 手动指定个人资料展示的教育经历
export function setProfileEducation (id) {
  return request({
    url: `/v1/user/education/${encodeURIComponent(String(id))}/display`,
    method: 'put'
  })
}

// 删除教育经历
export function deleteEducation (id) {
  return request({
    url: `/v1/user/education/${encodeURIComponent(String(id))}`,
    method: 'delete'
  })
}

// 提交绑定学校信息
export const bindSchool = (data) => {
  return request({
    url: '/v1/user/updateUser',
    method: 'POST',
    data
  })
}

export function selectUserInfoByToken (token) {
  return request({
    url: '/v1/user/selectUserInfoByToken',
    method: 'get',
    params: {
      token: token
    }
  })
}

// 重置密码
export function resetPassword (data) {
  return request({
    url: '/oauth/modifyPassword',
    method: 'post',
    data
  })
}
export function emailLogin (data) {
  return request({
    url: '/oauth/accountLogin',
    method: 'post',
    data: {
      ...data,
      device: 'PC'
    }
  })
}
export function forgetPassword (data) {
  return request({
    url: '/oauth/forgetPassword',
    method: 'put',
    data
  })
}
export function logout () {
  return request({
    url: '/oauth/logout',
    method: 'get',
    params: {
      device: 'PC'
    },
    skipTokenRefresh: true // 退出登录时不需要刷新token
  })
}
export function openAuthUrl (source) {
  return request({
    url: '/oauth/render/' + source,
    method: 'get'
  })
}
export function wxIsLogin (loginCode) {
  return request({
    url: '/oauth/wechat/is_login',
    method: 'get',
    params: {
      loginCode: loginCode
    }
  })
}
export function getWechatLoginCode () {
  return request({
    url: '/oauth/wechatLoginCode',
    method: 'get',

  })
}
export function sendEmailCode (email) {
  return request({
    url: '/oauth/sendEmailCode',
    method: 'get',
    params: {
      email: email
    }
  })
}
// 发送手机验证码
export function sendPhoneVerificationCode (phone) {
  return request({
    url: '/oauth/sendPhoneVerificationCode',
    method: 'get',
    params: {
      phone: phone
    }
  })
}
export function emailRegister (data) {
  return request({
    url: '/oauth/emailRegister',
    method: 'post',
    data
  })
}

// 验证码注册登录
export function captchaLogin (data) {
  return request({
    url: '/oauth/phoneLogin',
    method: 'post',
    data: {
      ...data,
      device: 'PC'
    }
  })
}
export function updateUserInfo (data) {
  return request({
    url: '/v1/user/updateUser',
    method: 'post',
    data
  })
}

// 修改用户背景图片
export function updateBackground (backgroundUrl) {
  return request({
    url: '/v1/user/updateBackground',
    method: 'post',
    params: { backgroundUrl }
  })
}
export function checkCode (code) {
  return request({
    url: '/v1/post/checkCode',
    method: 'get',
    params: {
      code: code
    }
  })
}
export function getUserInfo (userId) {
  return request({
    url: '/v1/user/info',
    method: 'get',
    params: {
      userId: userId
    }
  })
}

/**
 * 获取隐私设置
 *
 * 独立于 /v1/user/info：隐私开关只在设置面板里用，没必要挂到到处都在读的用户信息上
 * （那个 VO 还带 30 分钟服务端缓存，改完不容易立刻反映出来）。
 *
 * @returns {Promise} data - {
 *   onlineStatusVisible, privateAccount, searchable, recommendable, groupInviteAllowed, // 布尔
 *   followListVisible, fansListVisible,                                 // 人群档位（列表）
 *   postListVisible, schoolPostListVisible,                             // 人群档位（主页内容）
 *   dmPermission, atPermission,                                         // 人群档位（互动）
 *   audienceOptions                                                     // [{ code, desc }]
 * }
 *
 * 六项人群档位共用同一套编号：0-所有人 1-我关注的人 2-互相关注的人 3-仅自己/不允许任何人。
 * 档位文案由 audienceOptions 下发，前端不要再硬编码一份 —— web 和移动端各写一份
 * 迟早会漂移，之后加档位还得同时改三个仓库。
 *
 * postListVisible / schoolPostListVisible 管的是「别人进我主页能不能看到这个 tab」，
 * 不影响帖子在推荐流、同校区、搜索里的展示。
 *
 * 注意这里回的是「我设的档位」（0-3）。看别人主页时要的是「我能不能看」那个结论，
 * 读 /v1/user/info 的 postTabVisible / schoolPostTabVisible（布尔），两者不要混用。
 */
export function getPrivacySetting () {
  return request({
    url: '/v1/user/privacy/setting',
    method: 'get'
  })
}

/**
 * 修改隐私设置
 *
 * 只传要改的字段，未传的保持原值，响应回全量设置。
 * 一次只传当次改动的那一项：把全部项带上等于每拨一个开关都顺手重写其它项，
 * 两端状态有偏差（比如手机端刚改过）时就会互相覆盖。
 *
 * 不要走 updateUserInfo：那个接口强制要求昵称并会走一遍文本审核，
 * 只为拨一个开关把昵称重发一遍没有意义。
 *
 * @param {Object} data - 上面任意字段的子集；人群档位传非法值服务端会直接报错，
 *                        不会静默兜成默认值
 */
export function updatePrivacySetting (data) {
  return request({
    url: '/v1/user/privacy/setting',
    method: 'post',
    data
  })
}

/**
 * 获取匿名昵称及修改状态（账号设置 - 匿名昵称）
 *
 * data 是数组：绝大多数账号只有一个匿名身份，老账号族可能还剩两个，按建号先后排序。
 * 每项 { id, nickname, avatar, lastUpdateTime, nextUpdateTime, canUpdate, ruleTip }。
 * 能不能改、什么时候能再改都由服务端算好，前端不要自己按「半年」推算，
 * 规则文案也直接展示 ruleTip。
 */
export function getAnonymousNickname () {
  return request({
    url: '/v1/user/anonymousNickname',
    method: 'get'
  })
}

/**
 * 修改匿名昵称，每个匿名身份半年只能成功修改一次
 *
 * 不要走 updateUserInfo：那个接口只改实名身份。
 * 成功时 data 是修改后的完整状态（结构同 getAnonymousNickname 的单项），直接用它刷新界面。
 *
 * @param {Object} data
 * @param {String} data.id       匿名身份 id（来自 getAnonymousNickname，Long 以字符串传，避免精度丢失）
 * @param {String} data.nickname 新的匿名昵称
 */
export function updateAnonymousNickname (data) {
  return request({
    url: '/v1/user/anonymousNickname',
    method: 'post',
    data
  })
}

/**
 * 发送绑定手机号验证码
 *
 * 与登录用的 sendPhoneVerificationCode 是两个接口，别混用：这个要登录态，
 * 并且会先校验「当前账号是否已绑定」「该号是否被别人占用」，能在发短信之前
 * 就把无效请求挡掉。两者在服务端共用同一个 redis 验证码 key 与频控计数。
 *
 * @param {String} phone 手机号
 */
export function sendBindPhoneCode (phone) {
  return request({
    url: '/v1/user/sendBindPhoneCode',
    method: 'get',
    params: {
      phone: phone
    }
  })
}

/**
 * 绑定手机号
 *
 * 一个手机号只能绑一个账号，且当前账号已绑过就不能再绑（服务端没有换绑接口）。
 * 成功时 data 是脱敏后的手机号（138****8000），前端直接拿它更新展示。
 *
 * @param {Object} data
 * @param {String} data.phone            手机号
 * @param {String} data.verificationCode 6 位短信验证码
 */
export function bindPhone (data) {
  return request({
    url: '/v1/user/bindPhone',
    method: 'post',
    data
  })
}

/**
 * 注销账号前置校验
 *
 * 返回账号概览、是否允许注销（allowed / blockReasons）、注销后会失去的数据
 * （lossItems，带真实数量）、冷静期天数，以及 hasPassword —— 只有它为 true
 * 时才需要让用户输密码做二次身份校验（第三方 / 纯手机号账号没有密码）。
 */
export function deleteAccountCheck () {
  return request({
    url: '/v1/user/deleteAccountCheck',
    method: 'get'
  })
}

/**
 * 提交注销账号申请
 *
 * 提交后进入冷静期：账号立刻退出所有登录态，但数据、内容、社交关系全部保留；
 * 冷静期内用本账号重新登录即自动取消注销，所以没有单独的「撤销」接口。
 *
 * @param {Object} [data]
 * @param {String} [data.reason]   注销原因，选填
 * @param {String} [data.password] 登录密码，仅账号设置过密码时需要
 */
export function deleteAccount (data = {}) {
  return request({
    url: '/v1/user/deleteAccount',
    method: 'post',
    data
  })
}
